import React from 'react';
export function DotGridBackground() {
  return <div className="fixed inset-0 pointer-events-none z-0 opacity-30" data-id="element-600">
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-601">
        <defs data-id="element-602">
          <pattern id="dot-grid" x="0" y="0" width="32" height="32" patternUnits="userSpaceOnUse" data-id="element-603">
            <circle cx="2" cy="2" r="1" fill="currentColor" className="text-blue-400/40" data-id="element-604" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dot-grid)" data-id="element-605" />
      </svg>
    </div>;
}